import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('xeroProfitAndLossReport', 'xeroProfitAndLossReports');

const customActions = {
  async LOAD_xeroProfitAndLossReports({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('xeroProfitAndLossReports')
      .query({ $filter: 'IsDeleted eq false', $expand: 'ProfitAndLossItems($expand=Account)' });
    commit('SET_xeroProfitAndLossReports', data);
  },
};

export default { ...actions, ...customActions };
